// Wireframe Starter theme JS
document.addEventListener('DOMContentLoaded', function () {
  // Add interactive behavior here as needed.
});